import React, { useContext } from "react"
import { Link as GatsbyLink } from "gatsby"

import { handleMenuLinkClick } from "../../../handlers"
import { DrawerContext } from "../../../contexts"
import { capsStringAll } from "../../../utils"

import {
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  AccordionItem,
  Accordion,
  ListItem,
  VStack,
  List,
  Text,
  Link,
} from "@chakra-ui/react"

export default function MenuDropdown({ url, label, children }) {
  const { onClose } = useContext(DrawerContext)

  return (
    <Accordion allowToggle w="full">
      <AccordionItem border="none">
        <AccordionButton _expanded={{ pb: 4 }} _hover={{ color: "white" }}>
          {children}
          <Text as="span" size="lg" flex={1} textAlign="left">
            {label}
          </Text>
          <AccordionIcon boxSize={6} />
        </AccordionButton>
        <AccordionPanel py={5} bg="base.d100">
          <VStack as={List} spacing={5}>
            {url.map(({ fields }, index) => {
              return (
                <Link
                  onClick={event => {
                    handleMenuLinkClick(fields.slug, event)
                    onClose()
                  }}
                  as={GatsbyLink}
                  key={index}
                  to={fields.slug}
                  size="lg"
                  w="100%"
                >
                  <ListItem
                    position="relative"
                    color="gray.300"
                    pl="51px"
                    pr={2}
                    _before={{
                      border: "1px solid hsla(0,0%,100%,.05)",
                      transform: "translateY(-50%)",
                      boxShadow: "0 0 0 2px #E0E0E0",
                      position: "absolute",
                      borderRadius: "50%",
                      content: "''",
                      left: "14px",
                      minW: "8px",
                      top: "50%",
                      w: "8px",
                      h: "8px",
                    }}
                    _hover={{
                      _before: { boxShadow: "0 0 0 2px white" },
                      color: "white",
                    }}
                  >
                    {capsStringAll(fields.slug.split("/")[2])}
                  </ListItem>
                </Link>
              )
            })}
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}
